import { render, staticRenderFns } from "./FabricCalculatorBasic.vue?vue&type=template&id=c8cc29b2"
import script from "./FabricCalculatorBasic.vue?vue&type=script&lang=js"
export * from "./FabricCalculatorBasic.vue?vue&type=script&lang=js"
import style0 from "./FabricCalculatorBasic.vue?vue&type=style&index=0&id=c8cc29b2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports